import(/* webpackMode: "eager" */ "/builds/dev/b2c-portal/frontend/apps/web/src/app/error.tsx");
